// src/routes/AppRoutes.js
import React from "react";
import { Routes, Route } from "react-router-dom";

// Public Pages
import Login from "../Firebase/Login";
import ContactSupport from "../Firebase/contactSupport";

// Supplier Components
import Dashboard from "../Dashboard";
import UserOrders from "../Component/userOrders";
import UserQuotations from "../Component/userQuotations";
import UserQueries from "../Component/userQueries";
import UserNegotiations from "../Component/userNegotiations";
import AltAlarm from "../Component/altAlarm";
import SupplierProfile from "../Firebase/supplierProfile";
import Notification from "../Component/notifications";
import RaisedIssues from "../Component/raisedIssue";
import NewOffers from "../Component/newOffers";
import BrandRates from "../Component/brandRates";
import StockAvailability from "../Component/stockAvailability";
import ProductOffers from "../Component/productOffer";
import TransportGoodsReply from "../Component/transport-goods-reply";
import Finance from "../Component/finance";
import AccountDetails from "../Component/accountDetails";
import ClientRecords from "../Component/client-records/clientRecords";
import BroadcastingPage from "../Component/broadcast";
import SupplierChatbot from "../Component/chatbot";
import Support from "../Component/support";
import ClientDetails from "../Component/admin-components/clientsOverview";

// Admin Components
import AdminLogin from "../Component/admin-login";
import AdminDashboard from "../Component/admin-dashboard";

// Route Wrappers
import ProtectedRoute from "../Firebase/ProtectedRoute";
import AdminProtectedRoute from "../Component/AdminProtectedRoute";

// Fallback page
const NotFound = () => (
  <h1 style={{ padding: 40 }}>404 - Page Not Found</h1>
);

export default function AppRoutes() {
  return (
    <Routes>

      {/* ---------------------- PUBLIC ROUTES ---------------------- */}
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/contact-support" element={<ContactSupport />} />

      {/* ---------------------- SUPPLIER ROUTES ---------------------- */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/user-orders"
        element={
          <ProtectedRoute>
            <UserOrders />
          </ProtectedRoute>
        }
      />

      <Route
        path="/user-quotations"
        element={
          <ProtectedRoute>
            <UserQuotations />
          </ProtectedRoute>
        }
      />

      <Route
        path="/user-queries"
        element={
          <ProtectedRoute>
            <UserQueries />
          </ProtectedRoute>
        }
      />

      <Route
        path="/user-negotiations"
        element={
          <ProtectedRoute>
            <UserNegotiations />
          </ProtectedRoute>
        }
      />

      <Route
        path="/alt-alarm"
        element={
          <ProtectedRoute>
            <AltAlarm />
          </ProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <SupplierProfile />
          </ProtectedRoute>
        }
      />

      <Route
        path="/notifications"
        element={
          <ProtectedRoute>
            <Notification />
          </ProtectedRoute>
        }
      />

      <Route
        path="/raised-issues"
        element={
          <ProtectedRoute>
            <RaisedIssues />
          </ProtectedRoute>
        }
      />

      <Route
        path="/new-offers"
        element={
          <ProtectedRoute>
            <NewOffers />
          </ProtectedRoute>
        }
      />

      <Route
        path="/brand-rates"
        element={
          <ProtectedRoute>
            <BrandRates />
          </ProtectedRoute>
        }
      />

      <Route
        path="/finance"
        element={
          <ProtectedRoute>
            <Finance />
          </ProtectedRoute>
        }
      />

      <Route
        path="/stock-availability"
        element={
          <ProtectedRoute>
            <StockAvailability />
          </ProtectedRoute>
        }
      />

      <Route
        path="/product-offer"
        element={
          <ProtectedRoute>
            <ProductOffers />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account-details"
        element={
          <ProtectedRoute>
            <AccountDetails />
          </ProtectedRoute>
        }
      />

      <Route
        path="/client-records"
        element={
          <ProtectedRoute>
            <ClientRecords />
          </ProtectedRoute>
        }
      />

      <Route
        path="/broadcast"
        element={
          <ProtectedRoute>
            <BroadcastingPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/chatbot"
        element={
          <ProtectedRoute>
            <SupplierChatbot />
          </ProtectedRoute>
        }
      />

      <Route
        path="/support"
        element={
          <ProtectedRoute>
            <Support />
          </ProtectedRoute>
        }
      />

      <Route
        path="/transport-goods-reply"
        element={
          <ProtectedRoute>
            <TransportGoodsReply />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/clients-overview"
        element={
          <ProtectedRoute>
            <ClientDetails />
          </ProtectedRoute>
        }
      />

      {/* ---------------------- ADMIN ROUTES ---------------------- */}
      <Route path="/admin-login" element={<AdminLogin />} />

      <Route
        path="/admin-dashboard/*"
        element={
          <AdminProtectedRoute>
            <AdminDashboard />
          </AdminProtectedRoute>
        }
      />

      {/* ---------------------- 404 ROUTE ---------------------- */}
      <Route path="*" element={<NotFound />} />

    </Routes>
  );
}